// extracted by mini-css-extract-plugin
export default {"title":"DeepRoom_title_LNAuE","noBorder":"DeepRoom_noBorder_a7E0j"};